import React, { useState } from "react";
import styled from "styled-components";
import ApplePayIcon from "../../assets/svg/applepay.svg";
import PrimaryButton from "./PrimaryButton";

const Wrapper = styled.div``;
const Container = styled.div`
  font-size: 12px;
  padding: 14px 0px;
  border-bottom: 1px solid #b4b4b4;
  align-items: center;
`;
const Flex = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Option = styled.div`
  display: flex;
  align-items: center;
  input[type="radio"] {
    border: black;
  }
  span {
    margin-left: 5px;
  }
`;
const Button = styled.button`
  background-color: #03112a;
  margin: auto;
  border: none;
  width: 90%;
  color: white;
  font-size: 16px;
  font-weight: 300;
  text-align: center;
  padding: 12px;
  margin-top: 10px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

function PaymentButton() {
  const [showButton, setShowButton] = useState(false);
  const handleFlexClick = () => {
    setShowButton(true);
  };

  return (
    <Wrapper>
      <Container>
        <Flex onClick={handleFlexClick}>
          <Option>
            <input
              type="radio"
              id="option1"
              name="shippingMethod"
              value="Option1"
            />
            <span htmlFor="option1">Apple Pay</span>
          </Option>
          <img src={ApplePayIcon} alt="Apple Pay" />
        </Flex>
        {showButton && <Button>Continue with Apple Pay</Button>}
      </Container>
    </Wrapper>
  );
}

export default PaymentButton;